import { render } from "./HelloWorld.vue?vue&type=template&id=51d29dcc&bindings={\"msg\":\"props\"}"
import script from "./HelloWorld.vue?vue&type=script&lang=js"
export * from "./HelloWorld.vue?vue&type=script&lang=js"
script.render = render

export default script